<template>
  <div class="product">
    <div class="head">
      <slot></slot>
    </div>

    <div class="list">
      <ul>
        <li v-for="(item, index) of productlist" :key="index">
          <router-link :to="{ name: 'prodetail', query: { pid: item.goods_sn } }">
            <div class="p-img">
              <saas-img :src="item.pic"></saas-img>
            </div>
            <div class="name">
              <p>{{ item.goods_name }}</p>
            </div>

          </router-link>
          <div class="p-bottom">
            <div>
              <div class="price">
                {{ $setInfoDecimal(item.goods_price) }} 
              </div>
              <div class="marketPrice">
                <!-- {{ $setInfoDecimal(item.goods_marketPrice) }} -->
              </div>
            </div>
            <div class="addcar">
              <button @click="addcar(item.goods_sn)"></button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { addcar } from '@/api/car'
export default {
  props: {
    productlist: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  methods: {
    async addcar (id) {
      const result = await addcar({
        goods_sn: id,
        num: 1
      })
      this.$toast(result.data.data.message)
    }
  },
}
</script>
<style lang="scss" scoped>
.product {
  font-size: 0.32rem;
  .head {
    margin: 0.2rem;
  }
}
.list {
  font-size: 0.24rem;
  ul {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 2rem;
    li {
      a {
        color: #000;
      }
      width: 3.04rem;
      margin: 0.1rem 0.15rem;
      background: white;
      padding: 0.2rem;
      border-radius: 10px;
    }
    .price {
      color: #ff3131;
      font-size: 0.32rem;
    }
    .marketPrice{
      color: #b4b4b4;
      font-size: 0.2rem;
      text-decoration: line-through;
    }
    .p-img {
      width: 3.05rem;
      height: 3.05rem;
    }
    .name {
      height: 0.68rem;
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      p {
        margin: 0;
      }
    }
    .p-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.2rem 0;
    }
    .p-type {
      span {
        display: inline;
        border-radius: 30px;
        border: 1px solid #ff6161;
        color: #ff6161;
        font-size: 0.18rem;
        padding: 0.03rem 0.09rem;
        margin: 0 0.02rem;
      }
    }
    .addcar {
      button {
        width: 0.32rem;
        height: 0.32rem;
        background: url('../assets/icon/addcar.png') no-repeat;
        background-size: 0.32rem;
        border: none;
      }
    }
  }
}
</style>